import styled from 'styled-components';

export const Header = styled.div`
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
  box-sizing: border-box;
  height: 61px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 36px 16px 16px;
  border-bottom: 1px solid #d9d9d9;
`;

export const HeaderTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;
